/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=46c4cd58&"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js&"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports